import UploadDesignModal from "@/components/UploadDesignModal";
import { useState } from "react";

export default function CustomDesign() {
  const [open, setOpen] = useState(true);
  if (!open) return (
    <div className="max-w-2xl mx-auto py-24 px-6 text-center">
      <div className="font-serif text-[#EDE4D3] text-3xl mb-4">Thank you.</div>
      <button className="btn-bronze" onClick={() => setOpen(true)}>Send another design</button>
    </div>
  );
  return <UploadDesignModal open={open} onClose={() => setOpen(false)} />;
}
